<template>
  <Button class="collapse-button" @click="toggle">
    <Icon class="icon" :type="iconType"></Icon>
  </Button>
</template>

<script>
export default {
  name: 'AsideCollapse',

  props: {
    value: Boolean,
  },

  computed: {
    iconType() {
      return this.value ? 'md-arrow-dropright' : 'md-arrow-dropleft'
    },
  },

  methods: {
    toggle() {
      this.$emit('input', !this.value)
    },
  },
}
</script>

<style scoped lang="less">
  .collapse-button {
    position: absolute;
    width: 8px;
    height: 80px;
    padding: 0;
    right: -1px;
    top: 50%;
    border-radius: 0;
    transform: translateY(-40px);
    background: #409AE8;

    .icon {
      color: #fff;
      transform: translateX(-3px);
    }
  }
</style>
